import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "role-dialog"
};
const _hoisted_2 = {
  class: "dialog-footer"
};
import { reactive, computed, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
export default /*@__PURE__*/_defineComponent({
  __name: 'category-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    editRoleItem: {
      type: Object,
      default: () => {}
    },
    dialogType: {
      type: String,
      default: 'addSubset'
    },
    itemData: {
      type: Object,
      default: () => {}
    }
  },
  emits: ['closeDialog', 'restData'],
  setup(__props, {
    emit: __emit
  }) {
    const route = useRoute();
    const router = useRouter();
    const props = __props;
    const emit = __emit;
    const formRef = ref();
    const subBtnLoading = ref(false);
    const form = reactive({
      parent_id: null,
      name: '',
      type: 1,
      id: null
    });
    const rules = {
      parent_id: [{
        required: true,
        message: '请选择上级分类',
        trigger: 'change'
      }],
      name: [{
        required: true,
        message: '请输入分类名称',
        trigger: 'blur'
      }],
      type: [{
        required: true,
        message: '请选择分类类型',
        trigger: 'blur'
      }]
    };
    function restForm() {}
    function closeDialog() {
      if (subBtnLoading.value) return ElMessage.warning('正在保存，请稍后~~');
      restForm();
      emit('closeDialog');
    }
    function handleFooterBtn(actionType) {
      if (!actionType) {
        closeDialog();
        return;
      }
      formRef.value?.validate(valid => {
        if (valid) {
          submit();
        }
      });
    }
    async function submit() {}
    const title = computed(() => {
      if (props.dialogType === 'add') {
        return '添加分类';
      } else if (props.dialogType === 'edit') {
        return '编辑分类';
      }
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        "model-value": __props.dialogVisible,
        title: title.value,
        width: "25%",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true,
        "before-close": closeDialog
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = $event => handleFooterBtn(false))
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          loading: subBtnLoading.value,
          onClick: _cache[4] || (_cache[4] = $event => handleFooterBtn(true)),
          type: "primary"
        }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("确定")])),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: form,
          rules: rules,
          "label-width": "80px",
          "status-icon": ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "上级分类",
            prop: "parent_id"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.parent_id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.parent_id = $event),
              placeholder: "请选择上级分类"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "分类名称",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.name = $event),
              placeholder: "请输入分类名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "分类类型",
            prop: "type"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: form.type,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.type = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                label: 1,
                size: "large"
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("一级分类")])),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: 2,
                size: "large"
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("二级分类")])),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["model-value", "title"])]);
    };
  }
});